var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCaret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 559,
    viewBox: "0 0 318 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318 279.5C318.006 284.567 317.012 289.584 315.073 294.265C313.135 298.946 310.29 303.198 306.704 306.775L65.8049 547.733C58.5698 554.953 48.7652 559.006 38.545 559C28.3247 558.994 18.5246 554.931 11.2973 547.703C4.0701 540.475 0.00680155 530.673 8.9899e-06 520.45C-0.00678357 510.227 4.04348 500.42 11.2611 493.182L224.888 279.5L11.2611 65.8177C4.04349 58.5799 -0.00677807 48.7725 1.47365e-05 38.5498C0.00680754 28.327 4.07011 18.525 11.2973 11.2969C18.5246 4.06871 28.3247 0.00558664 38.545 -1.47991e-05C48.7652 -0.00561624 58.5698 4.04679 65.8049 11.267L306.704 252.225C310.29 255.802 313.135 260.054 315.073 264.735C317.012 269.416 318.006 274.433 318 279.5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCaret);
export default __webpack_public_path__ + "static/media/RightCaret.2515720f982a6b2657099588613537b1.svg";
export { ForwardRef as ReactComponent };